// bao migrate skip

import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabViewModel from "./../../factories/tab-controller";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-tabs";
import "./../../bindings/bao-number-box";
import AppTabController from "../../services/app-tab-controller";
function UserViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        var def = $.Deferred();
        if (self.Username() == null || self.Username() == "") {
            isComplete = false;
        }
        $.each(self.TabViewModel.Tabs(), function (index, tab) {
            if (tab.PreLoad()) {
                if (!tab.ViewModel().CompleteCheck()) {
                    self.TabViewModel.SelectTab(tab);
                    isComplete = false;
                    return false;
                }
            }
        });
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            def.resolve(false);
        }
        else {
            self.ValidateUsername().then(function (result) {
                if (result.Result == false) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserExistsInDb"), "info");
                    def.resolve(false);
                }
                else {
                    def.resolve(true);
                }
            });
        }
        return def.promise();
    };
    self.ValidateUsername = function () {
        return Bao.post("Uadm/User/ValidateUsername", JSON.stringify({
            userId: self.UserId(),
            userName: self.Username()
        }));
    };
    self.TabViewModel = new TabViewModel(false);
    self.UserTabs = ko.observableArray([]);
    self.UserTabs.subscribe(function (newValue) {
        self.TabViewModel.Tabs([]);
        $.each(ko.toJS(newValue), function (index, item) {
            if (item.PreLoad == null) {
                item.PreLoad = false;
            }
            var newTab = new TabPage(null, item.Caption);
            newTab.AutoSelect = false;
            newTab.Url(item.WebUrl);
            newTab.IsClosable(false);
            newTab.PreLoad(item.PreLoad);
            newTab.TabLoaded = function () { };
            self.TabViewModel.AddTab(newTab);
        });
        if (self.TabViewModel.Tabs().length > 0) {
            self.TabViewModel.SelectTab(self.TabViewModel.Tabs()[0]);
        }
    });

    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return $.when(self.HasResetPasswordPermission() && Bao.post("Uadm/User/ClearUserPassword", JSON.stringify({
            sessionTabId: self.TabPage.SessionTabId
        }))).then(function () {
            Bao.post(self.RefreshUrl, JSON.stringify({
                id: self.OpenData()
            }), function (value) {
                tabPage.DirtyFlag.pause();
                tabPage.ObjectId(self.OpenData());
                delete value.UserTabs;
                ko.map.fromJS(value, self);
                self.TabViewModel.RefreshTabs().then(function () {
                    tabPage.IsLoading(false);
                    tabPage.DirtyFlag.reset();
                });
            });
        });
    };

    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.SaveUrl, JSON.stringify({
            sessionTabId: self.TabPage.SessionTabId,
            model: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.TabViewModel.SaveTabs(value.Result).then(function () {
                tabPage.DirtyFlag(false);
                self.PerformRefresh();
            });
        });
    };
    self.MinimizeEntity = function () {
        var result = ko.map.toJS(self, true);
        delete result.UserTabs;
        delete result.Destroy;
        delete result.TabPage;
        delete result.TabViewModel;
        delete result.Uadm;
        return result;
    };
    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "UserResetPassword":
                    self.ResetPassword();
                    break;
                case "UserCopy":
                    self.CopyUser();
                    break;
                case "UserAudit":
                    self.OpenAuditDialog();
                    break;
                case "UserPermissionReport":
                    self.getPermissionReport();
                    break;
            }
        }
    });
    self.OpenAuditDialog = function () {
        window.baorequire(["Factories/BaseAuditDialog"], function (vm) {
            var auditDialog = new vm(self.UserId(), ko.unwrap(self.TabPage.Title), self.TabPage, "Uadm/User/GetAuditCollection");
            auditDialog.Open();
        });
    };

    self.getPermissionReport = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/User/ExportUserPermissionToXlsx", JSON.stringify({ userId: self.UserId() }),
            function (value) {
                if (value.message) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, value.Message, "info");
                }
                else {
                    window.open(window.absolutePath + "BaoDocument/Download/" + value.Result, "_blank");
                }
            }
        ).always(function () {
            tabPage.IsLoading(false);
        });
    };

    self.ResetPassword = function () {
        window.baorequire(["Uadm/ViewModels/Dialogs/UserResetPassword"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show();
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    tabPage.IsLoading(true);
                    Bao.post("Uadm/User/SetUserPassword", JSON.stringify({
                        sessionTabId: self.TabPage.SessionTabId,
                        password: dialog.DialogViewModel.Password1()
                    }), function () {
                        tabPage.IsLoading(false);
                        tabPage.DirtyFlag(true);
                    });
                }
            });
        });
    };
    self.ResetFailedLoginCounter = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/User/ResetFailedLoginCounter", JSON.stringify({
            userId: self.UserId()
        }), function (value) {
            if (value == true) {
                tabPage.DirtyFlag.pause();
                self.FailedLogins(0);
                tabPage.DirtyFlag.resume();
            }
            tabPage.IsLoading(false);
        });
    };
    var msgCopyUserMessage = Bao.Session.GetMessage("msgCopyUserMessage");
    self.CopyUser = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, msgCopyUserMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                tabPage.IsLoading(true);
                return Bao.post("Uadm/User/Copy", JSON.stringify({
                    model: self.MinimizeEntity()
                }), function (value) {
                    self.SaveTime(value.SaveTime);
                    var userId = value.NewUserId;
                    self.CopyUserTabs(userId);
                    var newTab = new TabPage();
                    newTab.Url("Uadm/User/Index");
                    newTab.UrlData({
                        id: userId
                    });
                    newTab.ObjectId(userId);
                    AppTabController.AddTab(newTab);
                    tabPage.IsLoading(false);
                });
            }
        });
    };
    self.CopyUserTabs = function (userId) {
        var saveDefArray = [];
        ko.utils.arrayForEach(self.TabViewModel.Tabs(), function (tab: any) {
            if (tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().Copy == "function") {
                saveDefArray[saveDefArray.length] = tab.ViewModel().Copy(userId, self.SaveTime());
            }
        });
        return $.when.apply($, saveDefArray);
    };
}
;
Bao.inherit(UserViewModel, SearchPaging);
UserViewModel.prototype.PrimaryKey = "UserId";
UserViewModel.prototype.DeleteMessageKey = "msgDeleteUser";
UserViewModel.prototype.RefreshUrl = "Uadm/User/GetUser";
UserViewModel.prototype.SaveUrl = "Uadm/User/SaveUser";
UserViewModel.prototype.DeleteUrl = "Uadm/User/Delete";
UserViewModel.prototype.PermissionForward = "UserMoveForwardSearch";
UserViewModel.prototype.PermissionBackward = "UserMoveBackwardSearch";
UserViewModel.prototype.PermissionSave = "UserSave";
UserViewModel.prototype.PermissionRefresh = "UserRefresh";
UserViewModel.prototype.PermissionDelete = "UserDelete";
export default UserViewModel;